module.exports = __webpack_public_path__ + "static/media/10C.bd17caf6.svg";